// These are the routes that are used in multiple components, routes that are only used
// once are in Container.tsx
export const VehicleSalesInvoicesURL = '/vehicle-sales/invoices'
export const VehicleSalesInvoicesDetailURL = '/vehicle-sales/invoices/:InvoiceUUID'

export const VehicleSalesQuotationsURL = '/vehicle-sales/quotations'
export const VehicleSalesQuotationsDetailURL = '/vehicle-sales/quotations/:QuotationUUID'

export const VehicleSalesInventoryDetailQuotationsURL =
  '/vehicle-sales/inventory/:PurchaseInvoiceUUID/details/vehicle/:VehicleUUID/quotations'
export const VehicleSalesInventoryDetailVehicleQuotationURL =
  '/vehicle-sales/inventory/:PurchaseInvoiceUUID/details/vehicle/:VehicleUUID/quotations/:QuotationUUID'

export const VehicleSalesInventoryURL = '/vehicle-sales/inventory'
export const VehicleSalesInventoryDetailURL = '/vehicle-sales/inventory/:PurchaseInvoiceUUID/details/'
export const VehicleSalesSupplierInvoiceURL = '/vehicle-sales/inventory/:PurchaseInvoiceUUID/create-invoice'
export const VehicleSalesInventoryDetailTransactionURL =
  '/vehicle-sales/inventory/:PurchaseInvoiceUUID/details/:TransactionType/:TransactionUUID'

export const VehicleSalesOpenTransactionsURL = '/vehicle-sales/open-transactions'
export const VehicleSalesOpenTransactionsDetailsURL = '/vehicle-sales/open-transactions/:TransactionType/:TransactionUUID'

export const VehicleSalesGlobalizationURL = '/vehicle-sales/reports/margin/globalization'
export const VehicleSalesGlobalizationDetailsURL = '/vehicle-sales/reports/margin/globalization/details'

export const VehicleSalesInitialStockURL = '/settings/vehicle-sales-initial-vehicle-stock'
